import { useTheme } from "../context/ThemeContext";

const VerticalDotsIcon = ({onClick}) => {
  const { darkMode } = useTheme();
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="button" onClick={onClick}>
<path d="M11.992 12H12.001" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9842 18H11.9932" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9998 6H12.0088" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export default VerticalDotsIcon;
